import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Unauthorized.css';

const Unauthorized: React.FC = () => {
  const { logout } = useAuth();

  const handleLogout = async () => {
    await logout();
  };

  return (
    <div className="unauthorized-page">
      <div className="unauthorized-container">
        <img 
          src={require('../../assets/logo.png')} 
          alt="Basketball Culture Logo" 
          className="login-logo"
        />
        
        <div className="unauthorized-icon">
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" 
            />
          </svg>
        </div>
        
        <h1 className="unauthorized-title">ACCESS DENIED</h1>
        <p className="unauthorized-message">
          You don't have permission to access the admin dashboard. Please contact an administrator if you believe this is an error.
        </p>
        
        <div className="button-container">
          <Link 
            to="/"
            className="home-button"
          >
            Return to Home
          </Link>
          
          <button
            onClick={handleLogout}
            className="logout-button"
          >
            Sign Out
          </button>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized; 